let avail = document.querySelector('.facets__summary-label')
avail.innerText = '選択肢'

let price = document.querySelector('.caption-large').children[0].children[0]
price.innerText = '価格'

let avail_label = document.querySelectorAll('.active-facets__button-inner')
if (avail_label.length !== 0) {
  for (let k=0;k<avail_label.length;k++){
  // console.log(avail_label[k].textContent)
    if (avail_label[k].textContent.includes('Availability: 在庫切れ')){
                            avail_label[k].innerText = '\
                        選択肢: 在庫切れ\
                        '
                        }
    if (avail_label[k].textContent.includes('Availability: 在庫あり')){
                            avail_label[k].innerText = '\
                        選択肢: 在庫あり\
                        '
                        }      
    avail_label[k].onclick = function(e){
      e.preventDefault();
      e.stopPropagation();
    }
  }

}

let zk = document.querySelector('.facets__disclosure-vertical')

let count = 0
zk.onclick = function(e){
  count += 1
  if (count === 2){
    count = 0
    return
  }
  // console.log('aaa')
  new Promise((res,rej)=>{
    let timer = setInterval(()=>{
      let avail = document.querySelector('.facets__summary-label')
      let price = document.querySelector('.caption-large').children[0].children[0]
      console.log(price.textContent)
      if (avail.textContent.includes('Availability')){
        // console.log('?????????????????????????????????????????????')
        clearInterval(timer)
        res('ok')
      }
    },500)
  }).then(value=>{
    // console.log('xia')
    let avail = document.querySelector('.facets__summary-label')
    let price = document.querySelectorAll('.caption-large.focus-offset')[1].children[0].children[0]
    let avail_label = document.querySelectorAll('.active-facets__button-inner')
    // console.log('asdasdasdasdasdadsaddd',price)
    avail.innerText = '選択肢'
    price.innerText = '価格'
    for (let k=0;k<avail_label.length;k++){
      // console.log(avail_label[k].textContent)
        if (avail_label[k].textContent.includes('Availability: 在庫切れ')){
                                avail_label[k].innerText = '\
                            選択肢: 在庫切れ\
                            '
                            }
        if (avail_label[k].textContent.includes('Availability: 在庫あり')){
                                avail_label[k].innerText = '\
                            選択肢: 在庫あり\
                            '
                            }      
        avail_label[k].onclick = function(e){
          e.preventDefault();
          e.stopPropagation();
        }
      }
    let sale = document.querySelectorAll('.card__badge .badge--bottom-left')
    for (let k = 0;k<sale.length;k++){
        let text = sale[k].innerText
        if (text === 'セール'){
          sale[k].style.color = 'green'
          sale[k].style.backgroundColor = '#f1f1f1'
        }else {
          sale[k].style.color = 'red'
          sale[k].style.backgroundColor = 'black'
        }
    }
    let sale2 = document.querySelectorAll('.price--large .badge')
    for (let k = 0;k<sale2.length;k++){
        let text = sale2[k].innerText
        if (text === 'セール'){
          sale2[k].style.color = 'green'
          sale2[k].style.backgroundColor = '#f1f1f1'
        }else {
          sale2[k].style.color = 'red'
          sale2[k].style.backgroundColor = 'black'
        }
    }
  })
}

